import React, { useRef, useEffect, useState } from 'react';

import classes from './Accordion.css'

const Accordion = ({ isOpen, content }) => {
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  const handleMaxHeight = () => {
    if (isOpen) {
      setMaxHeight(contentRef.current.scrollHeight + 'px');
    } else {
      setMaxHeight("0px");
    }
  }

  useEffect(() => {
    handleMaxHeight();
  }, []);

  useEffect(() => {
    handleMaxHeight();
  }, [isOpen]);

  return (
    <div style={{ maxHeight }} className={classes.Container} ref={contentRef}>
      {content}
    </div>
  )
}

export default Accordion;


// WEBPACK FOOTER //
// ./src/components/UI/Accordion/Accordion.js